import React from 'react'
import cx from 'classnames'
import { useRestaurant } from '@local/do-secundo-restaurant-provider'
import { Trans } from '@local/translations'

export const LegalCopy = ({ className }: { className?: string }) => {
  const { isIntlRx } = useRestaurant()

  return (
    <p
      className={cx('type-caption mx-1 mt-5', className)}
      data-testid='legal-links'
      role='group'
    >
      <Trans
        i18nKey={isIntlRx ? 'legal-copy.text-intl' : 'legal-copy.text'}
        components={{
          termsLink: (
            <a
              href={'https://pos.toasttab.com/terms-of-service/#diner-tos'}
              rel='noopener noreferrer'
              target='_blank'
              data-testid='link-terms-of-service'
              className='type-caption text-link'
            />
          ),
          privacyLink: (
            <a
              href={'https://pos.toasttab.com/privacy'}
              rel='noopener noreferrer'
              target='_blank'
              data-testid='link-privacy'
              className='type-caption text-link'
            />
          ),
          caLink: (
            <a
              href={'https://pos.toasttab.com/privacy#addendum-a'}
              rel='noopener noreferrer'
              target='_blank'
              data-testid='link-ca-addendum'
              className='type-caption text-link'
            />
          )
        }}
      />
    </p>
  )
}
